<template>
  <v-menu :close-on-content-click="false" top right>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon v-if="text === '' || text === null">mdi-filter</v-icon>
        <v-badge color="primary" v-else dot>
          <v-icon color="primary">mdi-filter</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card class="py-0 px-4" elevation="0">
      <v-autocomplete
        :items="items"
        :item-text="itemText"
        :item-value="itemValue"
        v-model="text"
        :label="label"
        clearable
        @click:clear="clearable()"
        @change="changeValue($event)"
      ></v-autocomplete>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    query: {
      type: String,
    },
    label: {
      type: String,
    },
    items: {
      type: Array,
    },
    itemText: {
      type: String,
    },
    itemValue: {
      type: String,
    },
  },

  data() {
    return {
      text: "",
    };
  },

  methods: {
    clearable() {
      this.text = "";
      this.$emit("clearable", {
        [`${this.query}`]: undefined,
      });
    },

    changeValue(event) {
      if (event != null) {
        this.$emit("texValue", {
          [`${this.query}`]: this.text,
        });
      }
    },
  },
};
</script>

<style></style>
